import * as React from 'react';
import { Menu } from 'antd';
import { Link, withRouter } from 'react-router-dom';
import { getPrivilegesTo } from '../../helpers/Users/getPrivilegesTo';
import { privileges } from 'data-layer/src/services/Users/privileges';
import {
  PieChartOutlined,
  CompassOutlined,
  BarcodeOutlined,
  AppstoreOutlined,
  TagOutlined,
  ContactsOutlined,
  SkinOutlined,
  AuditOutlined,
  TagsOutlined,
  ApiOutlined,
  NotificationOutlined,
  UserOutlined,
  TeamOutlined,
  GiftOutlined,
  SolutionOutlined,
  BankOutlined,
  PicCenterOutlined,
  FileTextOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  CreditCardOutlined,
  CarOutlined,
  LinkOutlined,
  InboxOutlined,
} from '@ant-design/icons';

class AppNavigation extends React.Component {

  public render() {
    const { eshop } = (this.props as any).match.params;

    return (
      <Menu theme="dark" mode="inline" style={{ lineHeight: '64px' }}>
        <Menu.Item key="1">
          <Link to={`/${eshop}/application/dashboard`}>
            <PieChartOutlined />
            <span>Dashboard</span>
          </Link>
        </Menu.Item>
        <Menu.SubMenu
          title={
            <span>
              <CompassOutlined />
              <span>Portfolio</span>
            </span>
          }
          key={'catalog'}
        >
          <Menu.Item key="4">
            <Link to={`/${eshop}/application/catalog`}>
              <CompassOutlined />
              <span>Catalog</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="2">
            <Link to={`/${eshop}/application/products`}>
              <BarcodeOutlined />
              <span>Products</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="3">
            <Link to={`/${eshop}/application/category`}>
              <AppstoreOutlined />
              <span>Categories</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="10">
            <Link to={`/${eshop}/application/attributes`}>
              <TagOutlined />
              <span>Attributes</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="11">
            <Link to={`/${eshop}/application/suppliers`}>
              <ContactsOutlined />
              <span>Suppliers</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="12">
            <Link to={`/${eshop}/application/manufacturers`}>
              <SkinOutlined />
              <span>Manufacturers</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="23">
            <Link to={`/${eshop}/application/availabilities`}>
              <AuditOutlined />
              <span>Availabilities</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="22">
            <Link to={`/${eshop}/application/product-tags`}>
              <TagsOutlined />
              <span>Tags</span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          title={
            <span>
              <ApiOutlined />
              <span>Sales</span>
            </span>
          }
          key={'sales'}
        >
          <Menu.Item key="20">
            <Link to={`/${eshop}/application/orders`}>
              <NotificationOutlined />
              <span>Orders</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="21">
            <Link to={`/${eshop}/application/customers`}>
              <UserOutlined />
              <span>Customers</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="25">
            <Link to={`/${eshop}/application/customerGroup`}>
              <TeamOutlined />
              <span>Groups</span>
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="17">
            <Link to={`/${eshop}/application/invoices`}>
              <CompassOutlined />
              <span>Invoices</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="18">
            <Link to={`/${eshop}/application/shipments`}>
              <CompassOutlined />
              <span>Shipments</span>
            </Link>
          </Menu.Item> */}
        </Menu.SubMenu>
        <Menu.SubMenu
          title={
            <span>
              <GiftOutlined />
              <span>Discounts</span>
            </span>
          }
          key={'vouchers'}
        >
          <Menu.Item key="30">
            <Link to={`/${eshop}/application/vouchers`}>
              <GiftOutlined />
              <span>Vouchers</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="31">
            <Link to={`/${eshop}/application/static-vouchers`}>
              <GiftOutlined />
              <span>Static Discounts</span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          title={
            <span>
              <SolutionOutlined />
              <span>Static Content</span>
            </span>
          }
          key={'static-content'}
        >
          <Menu.Item key="stores">
            <Link to={`/${eshop}/application/stores`}>
              <BankOutlined />
              <span>Stores</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="banners">
            <Link to={`/${eshop}/application/banners`}>
              <PicCenterOutlined />
              <span>Banners</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="staticDocuments">
            <Link to={`/${eshop}/application/static-documents`}>
              <FileTextOutlined />
              <span>Documents</span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key={'settings'}
          title={
            <span>
              <SettingOutlined />
              <span>Settings</span>
            </span>
          }
        >
          <Menu.Item key="24">
            <Link to={`/${eshop}/application/countries`}>
            <EnvironmentOutlined />
              <span>Countries</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="13">
            <Link to={`/${eshop}/application/languages`}>
              <GlobalOutlined />
              <span>Languages</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="17">
            <Link to={`/${eshop}/application/currency`}>
              <BankOutlined />
              <span>Currency</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="14">
            <Link to={`/${eshop}/application/paymentMethods`}>
              <CreditCardOutlined />
              <span>Payment methods</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="15">
            <Link to={`/${eshop}/application/deliveryMethods`}>
              <CarOutlined />
              <span>Delivery methods</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="18">
            <Link to={`/${eshop}/application/order-state`}>
              <LinkOutlined />
              <span>Order states</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="19">
            <Link to={`/${eshop}/application/letter-data`}>
              <InboxOutlined />
              <span>Letter data</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="27">
            <Link to={`/${eshop}/application/business`}>
              <BankOutlined />
              <span>Business</span>
            </Link>
          </Menu.Item>
          {getPrivilegesTo(privileges.USER_MANAGEMENT) &&
            <Menu.Item key="26">
              <Link to={`/${eshop}/application/account`}>
                <TeamOutlined />
                <span>Accounts</span>
              </Link>
            </Menu.Item>}
        </Menu.SubMenu>
      </Menu>
    );
  }
}

export default withRouter(AppNavigation as any);



// WEBPACK FOOTER //
// ./src/components/Layout/AppNavigation.tsx